import { useTranslation } from 'react-i18next';
import { BaseOffer, GuildOffer } from '../types/offers';

export const useOfferDescription = () => {
  const { t } = useTranslation();

  return {
    getOfferDescription: (
      offer: BaseOffer,
      type: 'regular' | 'guild',
    ) => {
      const { supply, maxSupply } = type === 'guild'
        ? { supply: (offer as GuildOffer).guildFounderSupply, maxSupply: (offer as GuildOffer).maxFounderSupply }
        : { supply: offer.individualSupply, maxSupply: offer.maxIndividualSupply };

      if (supply !== undefined) {
        const isUnlimited = maxSupply === null || maxSupply === undefined || maxSupply < 0;

        if (isUnlimited) {
          return [
            `${supply}`,
            type === 'regular'
              ? t('offerCard.rewardsPerPixionID')
              : t('offerCard.rewardsPerGuildFounder'),
          ].join(' ');
        }

        if (maxSupply !== undefined) {
          if (supply === 0) {
            const maxClaimDisplay = `${maxSupply}/${maxSupply}`;

            return offer.refreshTime
              ? [maxClaimDisplay, t('offerCard.maxClaimRefreshesIn')].join(
                ' ',
              )
              : maxClaimDisplay;
          }

          return [
            `${supply}/${maxSupply}`,
            type === 'regular'
              ? t('offerCard.rewardsPerPixionID')
              : t('offerCard.rewardsPerGuildFounder'),
          ].join(' ');
        }
      }

      return undefined;
    },
  };
};
